module.exports = __webpack_public_path__ + "static/media/New-Randomizer.7964a7a4.png";